module.exports = __webpack_public_path__ + "img/xuchangAppImage.b3f40264.png";